import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const createSession = async (metadata = {}) => {
  try {
    const response = await api.post('/sessions', { metadata })
    return response.data.data
  } catch (error) {
    console.error('Error creating session:', error)
    throw error
  }
}

export const getSession = async (sessionId) => {
  try {
    const response = await api.get(`/sessions/${sessionId}`)
    return response.data.data
  } catch (error) {
    console.error('Error getting session:', error)
    throw error
  }
}

export const updateSession = async (sessionId, livenessData) => {
  try {
    const response = await api.patch(`/sessions/${sessionId}`, { livenessData })
    return response.data.data
  } catch (error) {
    console.error('Error updating session:', error)
    throw error
  }
}

export const completeSession = async (sessionId, finalData) => {
  try {
    const response = await api.post(`/sessions/${sessionId}/complete`, finalData)
    return response.data.data
  } catch (error) {
    console.error('Error completing session:', error)
    throw error
  }
}

export default api
